/**
 * Footer horizontal nav: submenu toggles work with keyboard (Enter/Space), mouse,
 * and screen readers. Hover flyouts can be dismissed with Escape or by leaving the nav.
 */
(function () {
  function initFooterHorizontalNav() {
    var footer = document.querySelector('.footer-horizontal');
    if (!footer || footer.dataset.footerHorizontalNavBound === 'true') return;
    footer.dataset.footerHorizontalNavBound = 'true';

    var footerNav = footer.querySelector('.footer-horizontal__nav');
    var isMobile = function () {
      return window.matchMedia('(max-width: 900px)').matches;
    };

    var closeAllFooterSubmenus = function () {
      footer.querySelectorAll('.footer-menu-item.has-children.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        var t = openItem.querySelector('.footer-menu-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    };

    var skipNextClick = new WeakMap();

    function toggleFromButton(btn) {
      footer.classList.remove('footer--submenu-suppressed');

      var menuItem = btn.closest('.footer-menu-item.has-children');
      if (!menuItem) return;

      var isCurrentlyOpen = menuItem.classList.contains('is-open');

      footer.querySelectorAll('.footer-menu-item.has-children.is-open').forEach(function (openItem) {
        if (openItem !== menuItem) {
          openItem.classList.remove('is-open');
          var ot = openItem.querySelector('.footer-menu-toggle');
          if (ot) ot.setAttribute('aria-expanded', 'false');
        }
      });

      if (isCurrentlyOpen) {
        menuItem.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        menuItem.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        var sub = menuItem.querySelector('.footer-submenu');
        if (sub && typeof sub.scrollIntoView === 'function') {
          requestAnimationFrame(function () {
            sub.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          });
        }
      }
    }

    footer.querySelectorAll('.footer-menu-item.has-children').forEach(function (menuItem) {
      menuItem.addEventListener('mouseenter', function () {
        footer.classList.remove('footer--submenu-suppressed');
      });
      menuItem.addEventListener('mouseleave', function (e) {
        var to = e.relatedTarget;
        if (to && menuItem.contains(to)) return;
        footer.classList.remove('footer--submenu-suppressed');
      });
    });

    if (footerNav) {
      footerNav.addEventListener('mouseleave', function (e) {
        var to = e.relatedTarget;
        if (to && footerNav.contains(to)) return;
        requestAnimationFrame(function () {
          if (!footerNav.matches(':focus-within')) {
            closeAllFooterSubmenus();
            footer.classList.add('footer--submenu-suppressed');
          }
        });
      });
    }

    footer.querySelectorAll('.footer-menu-toggle').forEach(function (btn) {
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        e.stopPropagation();
        skipNextClick.set(btn, true);
        toggleFromButton(btn);
        window.setTimeout(function () {
          skipNextClick.delete(btn);
        }, 500);
      });

      btn.addEventListener('click', function (e) {
        if (skipNextClick.get(btn)) {
          skipNextClick.delete(btn);
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        toggleFromButton(btn);
      });
    });

    function pointerOverFooterNav() {
      if (!footerNav) return false;
      if (footerNav.matches(':hover')) return true;
      try {
        return !!footerNav.querySelector('.footer-menu-item:hover');
      } catch (err) {
        return false;
      }
    }

    function onEscape(e) {
      if (e.key !== 'Escape' || !footerNav) return;

      var hasToggleOpen = footerNav.querySelector('.footer-menu-item.has-children.is-open');
      var navHovered = pointerOverFooterNav();
      var focusInNav = footerNav.contains(document.activeElement);

      if (!hasToggleOpen && !navHovered && !focusInNav) return;

      closeAllFooterSubmenus();
      footer.classList.add('footer--submenu-suppressed');
      e.preventDefault();
    }

    document.addEventListener('keydown', onEscape);

    footer.querySelectorAll('.footer-menu-item.has-children .footer-menu-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!isMobile()) return;
        e.preventDefault();
        var t = link.closest('.footer-menu-item');
        var toggleBtn = t ? t.querySelector('.footer-menu-toggle') : null;
        if (toggleBtn) toggleBtn.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterHorizontalNav);
  } else {
    initFooterHorizontalNav();
  }
})();
